<script setup lang="ts">
import { computed } from 'vue';

import RouteLink from '@/components/base/RouteLink.vue';
import { flattenCategoryMetadata, gtag, ListMetadata, setListMetadata } from '@/utils/analytics';
import { CategoryCard } from '@/utils/category';

const props = defineProps<{ card: CategoryCard; position: number }>();

const count = computed(() => {
  const totalCount = Number(props.card.total);
  if (!totalCount) return null;

  return totalCount > 1 ? `${totalCount} items` : `${totalCount} item`;
});

const listMetadata = computed<ListMetadata>(() => ({
  category: {
    indexName: 'Departments',
    objectID: props.card.objectID,
    position: props.position,
    searchQueryID: props.card.queryID,
  },
  list: `CLP > ${props.card.name}`,
  position: props.position,
}));

const onClick = () => {
  const isSubCategory = props.card.type === 'department';
  const categoryMetadata = flattenCategoryMetadata(listMetadata.value.category, 'categoryMetadata');
  gtag('event', 'select_content', {
    ...categoryMetadata,
    content_id: isSubCategory
      ? `cat-${props.card.objectID}`
      : props.card.objectID.replace(/^P/, ''),
    content_type: isSubCategory ? 'sub-category' : 'PDP',
  });

  setListMetadata(listMetadata.value);
};
</script>

<template>
  <div class="w-full ptn-subcategory-teaser" data-test="clp-subcategory-teaser">
    <RouteLink
      :to="card.path"
      data-promo="1"
      data-promo-name="CLP Grid"
      :data-promo-creative="card.parentName ? `${card.parentName}: ${card.name}` : card.name"
      @click="onClick"
    >
      <div class="photo-container" data-test="photo-container">
        <img
          :alt="`Link to ${card.name}`"
          class="self-center mx-auto card-image"
          data-test="clp-images"
          :src="card.image"
        />
      </div>
      <h4 data-test="clp-product-title">{{ card.name }}</h4>
      <div v-if="count" class="count" data-test="product-count">{{ count }}</div>
    </RouteLink>
  </div>
</template>

<style scoped>
.card-image {
  margin-bottom: 0px !important;
}
</style>
